export function formatPrice(costPerSeat) {
  return `$${Number(costPerSeat).toFixed(2)}`
}

export const CARD_CLASSNAME = 'py-6 px-8 border-llama-grey-8 rounded-2xl'
export const CARD_TITLE_CLASSNAME = ' text-lg font-bold leading-[150%] text-llama-grey-7'
export const CARD_DESCRIPTION_CLASSNAME = ' text-base leading-[150%] text-llama-grey-5'
